export default __webpack_public_path__ + "static/media/Facilities-CACS-2.6a21aea1.jpg";